import MockEntityObjectCreator from "@/testing/MockEntityObjectCreator";
import { IEventDataSource } from "@/types/interfaces";
import { BigBashEvent, InputEventDetails } from "@/types/types";
import EventModifier from "@/utils/EventModifier";
import GameOrganizer from "@/utils/GameOrganizer";
import SmallHelpers from "@/utils/SmallHelpers";
import { typeConversionManager } from "@/utils/TypeConversionManager";

export enum EventDateFieldName {
	DATETIME = 'datetime',
}

class EventFormInputHandler {
	smallHelpers = new SmallHelpers();
	gameOrganizer = new GameOrganizer();
	mockEntityObjectCreator = new MockEntityObjectCreator();
	eventModifier = new EventModifier(this.eventDataSource, this.gameOrganizer, this.mockEntityObjectCreator);

	constructor(private eventDataSource: IEventDataSource) { }

	public handleDataChange(event: BigBashEvent, inputDetails: InputEventDetails): BigBashEvent {
		if (this.smallHelpers.isTeamInput(inputDetails.additionalIdentifier)) {
			return this._handleTeamInputChange(event, inputDetails);
		} else if (this.smallHelpers.isCustomerInput(inputDetails.additionalIdentifier)) {
			return this._handleCustomerInputChange(event, inputDetails);
		} else {
			if (!(inputDetails.name in event)) {
				console.warn(`Event does not have property: ${inputDetails.name}`);
				return event;
			}
			if (inputDetails.name === EventDateFieldName.DATETIME) {
				return {
					...event,
					datetime: typeConversionManager.convertStringToDate(inputDetails.value)
				};
			}
			return {
				...event,
				[inputDetails.name]: inputDetails.value
			};
		}
	}

	public handleDeleteTeam(event: BigBashEvent, teamIndex: number): BigBashEvent {
		const eventWithoutTeam = this.eventModifier.deleteTeam(event, teamIndex);
		return eventWithoutTeam;
	}

	private _handleTeamInputChange(event: BigBashEvent, inputDetails: InputEventDetails): BigBashEvent {
		if (!inputDetails.value) {
			return event;
		}
		const teamIndex = this.smallHelpers.getTeamIndexFromAdditionalIdentifier(inputDetails.additionalIdentifier);
		const eventWithNewOrUpdateTeam = this.eventModifier.addOrUpdateTeam(event, teamIndex, inputDetails);
		return eventWithNewOrUpdateTeam;
	}

	private _handleCustomerInputChange(event: BigBashEvent, inputDetails: InputEventDetails): BigBashEvent {
		if (!inputDetails.value) {
			return event;
		}
		const eventWithNewOrUpdateCustomer = this.eventModifier.addOrUpdateCustomer(event, inputDetails);
		return eventWithNewOrUpdateCustomer;
	}
}

export default EventFormInputHandler;